// import { AppConfiguration } from "config";
import { AppConfiguration } from "config";
import React from "react";
import { MetaTags } from "react-meta-tags";
import { Col, Container, Row } from "reactstrap";

const TermsSMSQF = () => {

    return (
            <div className="page-content" style={{ padding: '0px' }}>
                <React.Fragment>
                        <MetaTags>
                            <title>SMS/MMS Terms | {AppConfiguration.WEBSITE}</title>
                        </MetaTags>
                        <Container className='my-5 px-4'>
                            <Row className='d-flex justify-content-center text-justify mb-3'>
                                <Col>
                                    <div style={{lineHeight: '1.7'}}>
                                        <h1 className="quote-funnel-answer-header text-black text-start">Goal Insurance Advisor SMS/MMS Terms of Service.</h1>

                                        <p className="fs-16">
                                            <ol>
                                                <li>When users opt-in they can expect periodic text messages regarding insurance products and opportunities available in their geographic area.</li>
                                                <li>You can cancel the short code service at any time. Just text "STOP" to the short code. After you send the short code message "STOP" to us, we will send you an short code message to confirm that you have been unsubscribed. After this, you will no longer receive short code messages from us. If you want to join again, just sign up as you did the first time and we will start sending short code messages to you again.</li>
                                                <li>Data obtained through the short code program will not be shared with any third-parties for their marketing purposes.</li>
                                                <li>If you are experiencing issues with the messaging program you can reply with the keyword HELP for more assistance, or you can get help directly at info@checkoutgoal.com.</li>
                                                <li>Carriers are not liable for delayed or undelivered messages.</li>
                                                <li>As always, message and data rates may apply for any messages sent to you from us and to us from you. Message frequency varies. If you have any questions about your text plan or data plan, it is best to contact your wireless provider.</li>
                                                <li>If you have any questions regarding privacy, please read our <a href= "/privacy-policy" target="_blank" className="text-sfblue">privacy policy</a></li>
                                            </ol>
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                </React.Fragment>
            </div>
    )
}

export default TermsSMSQF;